<template>
  <v-form @submit.prevent="submit">
      <v-container class="mt-2">
          <v-row  justify="center" align="center">
            <StatusMessage :successmsg="success_msg" :errormsg="error_msg" style="width: 500px;"></StatusMessage>
          </v-row>
          <v-row justify="center" align="center">
            <v-card class="white--text" color="secondary" width="500" dark>
              <v-card-title class="pt-8 white--text justify-center">
                Forgot Password
              </v-card-title>
              <v-card-text>
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="form.email"
                      :error-messages="errors.email"
                      label="E-mail"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="12"
                    class="text-center"
                  >
                  </v-col>
                </v-card-text>
                <v-card-actions class="justify-space-between my-4">
                  <v-btn text @click="toLogin">Login</v-btn>
                  <v-btn rounded class="primary" type="submit">Submit</v-btn>
                </v-card-actions>
                <LoadingOverlay :loading="loading"></LoadingOverlay>
            </v-card>
          </v-row>
      </v-container>
  </v-form>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import StatusMessage from '@/components/utils/StatusMessage'
  import LoadingOverlay from '@/components/utils/LoadingOverlay'

  export default {
    name: 'ForgotPassword',
    components: {
      StatusMessage,
      LoadingOverlay
    },
    data () {
      return {
        form: {
          email: '',
        },
      }
    },
    computed: {
      ...mapGetters({
        errors: 'auth/errors',
        error_msg: 'auth/error_msg',
        success_msg: 'auth/success_msg',
        loading: 'auth/loading'
      })
    },
    methods: {
      ...mapActions({
        forgotPassword: 'auth/forgotPassword',
      }),
      ...mapMutations({
        clearMessages: 'auth/RESET_MSGS',
      }),
      async submit () {
        await this.forgotPassword(this.form)
      },
      toLogin() {
        this.clearMessages()
        this.$router.push({name: 'Login'})
      }
    },
    mounted() {
    }
  }
</script>